import { Price } from '@/components/shared/Price'

type Props = {
  amount: number
  currency?: string
}
export const AuditPriceDisplay = ({ amount, currency }: Props) => {
  return (
    <Price
      amount={amount}
      size="lg"
      currency={currency}
      className="flex-none basis-[10rem]"
    />
  )
}
